import { Injectable } from "@angular/core";
import { Observable, lastValueFrom, map, of } from "rxjs";
import { HttpService } from "../http.service";
import Bugsnag from "@bugsnag/js";
import { CacheService } from "../cache.service";
import { GAService } from "../ga.service";
import { Constants } from "@apps/patient-core/constants";
import { WindowService } from "../window.service";
import { NavigationService } from "../navigation.service";
import { notifyAndLeaveBreadcrumb } from "../../utils/logging";
import { LocationService } from "../location.service";
import { AnalyticsService } from "../analytics.service";
import { FeatureFlagsService } from "../feature-flags.service";
import { BaseAuthService } from "./auth.service";

const SESSIONS_PATH = "/api/v1/sessions";
export const TOKEN_STORAGE_KEY = "token";

@Injectable()
export abstract class BaseSessionService {
  constructor(
    protected _httpService: HttpService,
    protected _authService: BaseAuthService,
    protected _cacheService: CacheService,
    protected _gaService: GAService,
    protected _windowService: WindowService,
    protected _navigationService: NavigationService,
    protected _locationService: LocationService,
    protected _analyticsService: AnalyticsService,
    protected _featureFlagsService: FeatureFlagsService
  ) {
    this._authService.onSessionIdChanged.subscribe(() => {
      this._setSessionId();
    });
  }

  public get isPasswordRequired(): boolean {
    return false;
  }
  public abstract onPageUnload(): void;

  public abstract init(): Promise<void>;

  public async clear(): Promise<void> {
    try {
      await lastValueFrom(
        this._httpService.send(SESSIONS_PATH, {
          method: "DELETE",
        })
      );
    } catch (error) {
      notifyAndLeaveBreadcrumb("Failed to clear session", error);
    }
    this._authService.delete();
  }

  public async logout(signoutPath = "/signout"): Promise<void> {
    this._cacheService.deleteSession(Constants.PATIENT_ACTIONS_SESSION_STORAGE_KEY);
    Bugsnag.leaveBreadcrumb("Sign out");
    this._gaService.action("signout");
    this._cacheService.clearSession();
    await this.clear();
    this._windowService.href = signoutPath;
  }

  public startKeepAlive(): void {}
  public onPasswordValidated(): void {}
  public extendSession(_password: string): Observable<void> {
    return of();
  }

  public async getNewSession(): Promise<void> {
    return Promise.resolve();
  }

  protected _setSessionId(): void {}

  protected _getSession(): Observable<string | null> {
    return this._httpService
      .send(SESSIONS_PATH, {
        method: "GET",
      })
      .pipe(map((response: { jwt: string } | null) => response?.jwt || null));
  }
}
